import React, { useMemo, memo } from 'react';
import SplitShiftDetailsOverlay from '../shifts/SplitShift/SplitShiftDetailsOverlay';

import Confirmed from '../../assets/images/badge-confirmed.svg';
import Guaranteed from '../../assets/images/badge-guaranteed.svg';
import Bundle from '../../assets/images/badge-bundle.svg';
import OnCall from '../../assets/images/badge-on-call.svg';
import MarkedAsCalledBack from '../../assets/images/marked-as-callback-badge-icon.svg';
import CallbackShift from '../../assets/images/callback-shift-badge-icon-green.svg';
import Orientation from '../../assets/images/badge-orientation.svg';
import Integrated from '../../assets/images/badge-integrated.svg';
import ArrowSplitIcon from '../../assets/images/arrow-split-gray.svg';
import ArrowSplitPartialCancelledIcon from '../../assets/images/arrow-split-partial-cancelled.svg';

import Utils from '../../utils/utils';
import SLOT_STATUSES from '../../constants/slotStatuses';
import { GLOBAL_CALENDAR_SHIFT_TYPES } from '../../constants';
import Tooltip from '../../components/Tooltip/Tooltip';

import './SlotBadges.scss';

const SlotBadges = ({ shift, slot }) => {
	const shouldShowBadges = useMemo(
		() =>
			slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT ||
			!!slot.is_guaranteed ||
			!!slot.contract_id ||
			!!shift.is_orientation ||
			!!slot.is_integrated ||
			!!shift.is_on_call ||
			!!slot.has_segments,
		[shift, slot]
	);

	// if on-call slot is not marked as called back, we show the on-call badge
	const isOnCall = !!shift.is_on_call && slot.is_on_call && !slot.marked_as_callback;
	// if on-call slot is marked as called back, we show the marked as called back badge
	const isMarkedAsCalledBack = !!shift.is_on_call && slot.is_on_call && slot.marked_as_callback;
	// if slot is callback, we show the callback badge
	const isCallback = !!shift.is_on_call && !!slot.on_call_slot_id;
	const isPartiallyCancelled = !!slot.split_adjusted_start_time || !!slot.split_adjusted_end_time;
	const splitIcon = isPartiallyCancelled ? ArrowSplitPartialCancelledIcon : ArrowSplitIcon;

	return (
		shouldShowBadges && (
			<div className="slot-badges__container">
				<div className="slot-badges__left">
					{slot.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT && shift.shift_type !== GLOBAL_CALENDAR_SHIFT_TYPES.FLEX && (
						<Tooltip label="Confirmed" placement="top">
							<img src={Confirmed} width={14} height={14} alt="Confirmed" />
						</Tooltip>
					)}
				</div>
				<div className="slot-badges__right">
					{!!slot.has_segments && (
						<SplitShiftDetailsOverlay
							slotId={slot.slot_id}
							managementCompanyId={slot.management_company_id}
							triggerClassName="slot-badges__split"
							segmentsCount={slot.segments_count}
						>
							<img src={splitIcon} alt="Show Segments" />
						</SplitShiftDetailsOverlay>
					)}
					{!!shift.is_orientation && (
						<Tooltip label="Orientation" placement="top">
							<img src={Orientation} alt="Orientation" />
						</Tooltip>
					)}
					{Utils.shouldShowIntegratedBadge(slot, slot.is_integrated) && (
						<Tooltip label="Integrated" placement="top">
							<img src={Integrated} alt="Integrated" />
						</Tooltip>
					)}
					{!!slot.contract_id && (
						<Tooltip label="Bundle" placement="top">
							<img src={Bundle} alt="Bundle" />
						</Tooltip>
					)}
					{isOnCall && (
						<Tooltip label="On Call shift" placement="top">
							<img src={OnCall} width={14} height={14} alt="On Call shift" />
						</Tooltip>
					)}
					{isMarkedAsCalledBack && (
						<Tooltip label="Marked as Called Back" placement="top">
							<img src={MarkedAsCalledBack} width={14} height={14} className="gs-marked-as-called-back-badge" alt="" />
						</Tooltip>
					)}
					{isCallback && (
						<Tooltip label="Callback shift" placement="top">
							<img src={CallbackShift} width={14} height={14} className="gs-callback-shift-badge" alt="" />
						</Tooltip>
					)}
					{!!slot.is_guaranteed && (
						<Tooltip label="Guaranteed" placement="top">
							<img src={Guaranteed} alt="Guaranteed" />
						</Tooltip>
					)}
				</div>
			</div>
		)
	);
};

export default memo(SlotBadges);
